// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"toolTip_wrapper__KtlCN","tooltip":"toolTip_tooltip__wqUw2","hidden":"toolTip_hidden__3Ie5B"};